/* eslint-disable import/no-duplicates */
import angular from "angular"

import BootstrapService_ from "../../services/bootstrap/bootstrap.service"
import type BootstrapService from "../../services/bootstrap/bootstrap.service"
import type StaticContentService from "../../services/static/static-content.service"

export class RootController {
  constructor(
    private $state: angular.ui.IStateService,
    private $scope: angular.IScope,
    private BootstrapService: BootstrapService,
    private StaticContentService: StaticContentService,
  ) {
    "ngInject"

    this.$scope.$on(BootstrapService_.EVENT_STATE, () => {
      this.stateUpdated()
    })

    // TODO: Connection toast removed for connection issues. Uncomment when issues are resolved.
    // this._connectionIndicator = new ConnectionIndicator(FirebaseService, BootstrapService, $scope, $mdToast, $timeout);
    // this._connectionIndicator.start();

    this.StaticContentService.recommendBestBrowser()
  }

  // Called when the state of the bootstrap service changes,
  // when bootstrap is complete, this reloads the child state so that the constructor is run again
  // We reload only the child state so that the animation can effectively animate in the loaded state. If we
  // reload the whole page, no animation plays because the HTML including the animation is reloaded.
  private stateUpdated(): void {
    if (this.state === "ready") {
      this.$state.go(
        this.$state.current,
        {},
        { reload: this.firstChild(this.$state.current.name ?? "") },
      )
    }
  }

  // Returns the name of the first child of the this state - 'root.[child]'
  private firstChild(stateName: string): string {
    let idx = stateName.indexOf(".")
    idx = stateName.indexOf(".", idx + 1)
    if (idx < 0) {
      return stateName
    }
    return stateName.substring(0, idx)
  }

  get state(): string {
    return this.BootstrapService.state
  }

  get errorMessage(): string {
    return this.BootstrapService.errorMessage
  }
}
